import './App.css';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './pages/Home';
import Deck from './pages/Deck';
import ShareDeck from './pages/ShareDeck';
import ShareDeck2 from './pages/ShareDeck2';

function App() {
  const reload = () => window.location.reload();
  return (
    <Router>
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route path='/deck' element={<Deck/>} />
        <Route path='/share-deck' element={<ShareDeck/>} />
        <Route path='/share-deck2' element={<ShareDeck2/>} />
        {/* API for cards data */}
        <Route path='/data/d4k.json' onEnter={reload} />
        <Route path='/data/starter.json' onEnter={reload} />
        <Route path='/data/alleluia.json' onEnter={reload} />
        <Route path='/data/stardust.json' onEnter={reload} />
        <Route path='/data/ekklesia.json' onEnter={reload} />
        <Route path='/data/treasure.json' onEnter={reload} />
      </Routes>
    </Router>
  );
}

export default App;
